import React, { Component } from 'react';

class Homepage extends Component {

  render() {
    return (
      <section className="hero">
      <section className="hero is-fullheight">
        <div className="hero-body">
          <div className="container intro has-text-centered">
            <h1 className="title logo">Angie Rodriguez</h1>
            <h3 className="subtitle is-3"><strong>I'm a front-end developer based in the Portland, OR area.</strong></h3>
          </div>
        </div>
      </section>
      </section>
    )
  }
}

export default Homepage;
